//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import InquiryType from '~/components/search/inquiry/mixins/InquiryType'

export default {

    name: 'InquiryProject',

    mixins: [ InquiryType ],

    props: {
        reference: {
        },
        inquiryType: {
        },
        inquiryFavlistId: {
        },
        countries: {
        },
        contact: {
        },
        project: {
        },
        destinationId: {
        }
    },

    data() {
        return {
            step: 'contact',
            projectTypes: {},
            projectBudgets: {},
        }
    },

    created() {
        this.getData()
    },

    methods: {

        formatDate(start, end) {

            let startDate = this.$dateFns.format(start,'dd MMM yyy')

            if(end) {
                const endDate = this.$dateFns.format(end,'dd MMM yyy')

                return startDate + ' - ' + endDate
            }

            return startDate
        },

        onSubmit() {

            let _this = this
            let rfpFile = ''
            let rfpFileOrigName = ''

            let projectDate = this.formatDate(this.project.dateStart, this.project.dateEnd)


            if(this.project.fileDocument && this.project.fileDocument !== null) {
                rfpFile = this.project.fileDocument.upload.data.fileName
                rfpFileOrigName = this.project.fileDocument.upload.origFilename
            }



            const formData = {

                'request_type': 'project',
                'request_id': this.reference,

                'inquiry_type': this.inquiryType,

                'destination_id': this.destinationId,

                'inquiry_favlist_id': this.inquiryFavlistId,

                'project_company': this.contact.company,
                'project_firstname': this.contact.firstName,
                'project_lastname': this.contact.lastName,
                'project_jobtitle': this.contact.jobTitle,
                'project_email': this.contact.email,
                'project_phone': this.contact.phoneNumber,
                'project_country': this.contact.country.id,

                'project_destination_pitch': this.project.destinationPitch,
                'project_destination_description': this.project.destinationDescription,
                'project_date': projectDate,
                'project_duration': this.project.duration,
                'project_amount_guests_pax': this.project.amountGuest,
                'project_budget': this.project.budget,
                'project_name': this.project.projectName,
                'project_type': this.project.projectType,
                'project_travel_of_attendies': this.project.travelOfAttendees,
                'project_special_requirements': this.project.specialRequirements,
                'project_activities': this.project.activities,
                'project_accommodation_required': this.project.accommodationRequired,

                'rfpFile': rfpFile,
                'rfpFileOrigName': rfpFileOrigName,
            }

            this.$axios.post(this.$ziggy.route('search.inquiry.send'), formData)
                .then((response) => {
                    _this.$logger.debug('send rfp', response)
                    _this.$emit('step', 'successful')
                })
                .catch((e) => {
                    this.$toast.global.my_error()
                    _this.$logger.captureException(e)
                })

        },

        getData: async function () {

            try {
                const response = await this.$axios.$get(this.route('api.content.inquiry.data'))
                this.projectTypes = response.project_types
                this.projectBudgets = response.project_budgets

            } catch (e) {
                this.$logger.captureException(e)
            }

        },

    },

    computed: {

        projectBudgetsSelect() {

            let _this = this
            let budgets = []

            Object.keys(this.projectBudgets).forEach(function(key) {

                budgets.push({
                    html: _this.projectBudgets[key],
                    value: key
                })
            });

            return budgets

        },

        projectTypesSelect() {

            let _this = this
            let types = []

            Object.keys(this.projectTypes).forEach(function(key) {

                types.push({
                    html: _this.projectTypes[key],
                    value: key
                })
            });

            return types

        }

    }


}

